import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  buttonsWrapper: {
    display: 'flex',
    gap: theme.spacing(1),
    // justifyContent: 'space-between',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
}));
